module.exports = __webpack_public_path__ + "static/po-intro-img-3-a0fd08145718b98682892893ff6c4395.png";